/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React, { useState, useEffect } from 'react';
import { CheckboxWithLinks } from '../Inputs';
import { Link } from '../Link/Link';

import './agreements.scss';
import { useWidgetProps } from '../../WidgetPropsContext';
import { providerConsents } from '../../providerConsents';

const onlineBookingConsentText =
    'согласие на обработку моих персональных данных для онлайн-записи на оказание медицинской помощи с внесением сведений в медицинские информационные системы(ресурсы)';
const onlineBookingChildConsentText =
    'согласие на обработку персональных данных моего ребенка для онлайн-записи на оказание медицинской помощи с внесением сведений в медицинские информационные системы (ресурсы)';

const agreements = require('b_').with('agreements');

export const Agreements = ({ onChange, isChild = false }) => {
    const { consentsEnabled, mcName, providerCode } = useWidgetProps();
    const [ isUserDataArg, setIsUserDataArg ] = useState(false);
    const [ isUserAgreementAccepted, setIsUserAgreementAccepted ] = useState(false);
    const [ isPdpAccepted, setIsPdpAccepted ] = useState(false);

    const currentConsents = providerConsents[providerCode];
    const pdpUrl = currentConsents
        ? (isChild ? currentConsents.onlineBookingChildLink : currentConsents.onlineBookingLink)
        : null;

    useEffect(() => {
        if (consentsEnabled === true) {
            onChange(!pdpUrl || isUserDataArg);
        } else {
            onChange(isUserAgreementAccepted && isPdpAccepted);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ consentsEnabled, pdpUrl, isUserDataArg, isUserAgreementAccepted, isPdpAccepted ]);

    if (consentsEnabled === true && !pdpUrl) {
        return null;
    }

    const onChangeUserDataAgr = () => {
        const next = !isUserDataArg;
        setIsUserDataArg(next);
    };

    const legacyAgreements = [
        {
            id: 'checkbox-user-agreement',
            value: isUserAgreementAccepted,
            onChange: () => setIsUserAgreementAccepted(!isUserAgreementAccepted),
            label: <>Я принимаю <Link href="https://aibolit.by/user-agreement" title="условия пользовательского соглашения"/> и <Link href="https://aibolit.by/privacy" title="политику конфиденциальности"/>.</>,
        },
        {
            id: 'checkbox-pdp',
            value: isPdpAccepted,
            onChange: () => setIsPdpAccepted(!isPdpAccepted),
            label: <>Я даю <Link href="https://aibolit.by/pdp" title="согласие на обработку персональных данных"/>.</>,
        },
    ];

    return (
        <div className={agreements('body')}>
            {consentsEnabled === true ? (
                <div className={agreements('checkbox')}>
                    <CheckboxWithLinks
                        customLabel={
                            <div className={agreements('label-text')}>
                                Я даю {mcName} <Link href={pdpUrl}
                                    title={isChild ? onlineBookingChildConsentText : onlineBookingConsentText}/>
                            </div>
                        }
                        value={isUserDataArg}
                        onChange={onChangeUserDataAgr}
                        id="checkbox-agreement-sec"
                    />
                </div>
            ) : legacyAgreements.map(({
                id, value, onChange: onChangeAgreement, label,
            }) => (
                <div className={agreements('checkbox')} key={id}>
                    <CheckboxWithLinks
                        customLabel={<div className={agreements('label-text')}>{label}</div>}
                        value={value}
                        onChange={onChangeAgreement}
                        id={id}
                    />
                </div>
            ))}
        </div>
    );
};
